import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { BaseApiResponse } from 'app/core/models/api/api.model';
import { environment } from '../../../../environments/environment';
import { FamilyMedicalHistory } from 'app/core/models/family-medical-history/family-medical-history.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FamilyMedicalHistoryService {
  constructor(private apiService: ApiService) {}

  async getListFamilyMedicalHistory(): Promise<
    BaseApiResponse<FamilyMedicalHistory[]>
  > {
    return await firstValueFrom(
      this.apiService.get<FamilyMedicalHistory[]>(
        `${environment.apiLocations.patient}/familymedicialhistory`
      )
    );
  }
}
